import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { setCatNav } from './../redux/actions';
import PageWrapper from './../components/PageWrapper';
import Hero from './../components/hero/Hero';
import CategoryNavWrapper from './../components/filter-pages/CategoryNavWrapper';
import FilmArtGrid from './../components/filter-pages/FilmArtGrid';
import { filterCategory, removeHidden } from './../scripts';

class FineArtLanding extends Component {
  componentWillMount() {
    this.props.setCatNav([]);
  };
  render() {
    return (
      <PageWrapper pageId={'portfolio-landing'}>
        <Hero sliderContent={this.props.staticContent.fineArtData.data.hero_slider}/>
        <CategoryNavWrapper/>
        <FilmArtGrid
          GridItems={filterCategory(removeHidden(this.props.staticContent.fineArtData.data.exhibition_grid), this.props.category)}
          Page={'fine-art'}
        />
      </PageWrapper>
    );
  };
};

export default connect(
  state => ({
    staticContent: state.staticContent,
    route: state.router.location_data.pathname,
    category: state.current_sub_category
  }),
  dispatch => ({
    setCatNav: (navigation) => dispatch(setCatNav(navigation))
  })
)(FineArtLanding);



// WEBPACK FOOTER //
// ./src/pages/FineArtLanding.js